module.exports = __webpack_public_path__ + "static/media/s_v10_22.93662cbf.mp3";